module.exports = __webpack_public_path__ + "images/pmc-white.png";


//////////////////
// WEBPACK FOOTER
// ./assets/pmc-white.png
// module id = 8
// module chunks = 0